// extracted by mini-css-extract-plugin
module.exports = {"contents":"contents___gB-zj","onboardingBanner":"onboardingBanner___AIEL2","messageBar":"messageBar___2RcmM","icon":"icon___2gxX1"};